import map from 'staticfile'
import htmlComponent from 'htmlcomponent'

htmlComponent.setStaticLoader(map);
htmlComponent.query(document);
